import { addIcons } from 'ionicons';
import {
  addOutline,
  alertCircleOutline,
  arrowForward,
  arrowUndoOutline,
  banOutline,
  bedOutline,
  businessOutline,
  cashOutline,
  cafeOutline,
  cardOutline,
  calendarOutline,
  callOutline,
  carOutline,
  chatbubbleEllipsesOutline,
  chevronForwardOutline,
  closeOutline,
  compassOutline,
  copyOutline,
  createOutline,
  documentTextOutline,
  enterOutline,
  exitOutline,
  checkmarkCircle,
  checkmarkOutline,
  checkmarkDoneOutline,
  chevronBackOutline,
  closeCircleOutline,
  downloadOutline,
  ellipseOutline,
  chevronDownOutline,
  eyeOutline,
  flashOutline,
  globeOutline,
  headsetOutline,
  helpCircleOutline,
  homeOutline,
  informationCircleOutline,
  keyOutline,
  location,
  locationOutline,
  lockClosedOutline,
  logOutOutline,
  mailOutline,
  menuOutline,
  notificationsOutline,
  optionsOutline,
  pawOutline,
  peopleOutline,
  personOutline,
  pricetagOutline,
  qrCodeOutline,
  removeOutline,
  resizeOutline,
  searchOutline,
  shareOutline,
  shirtOutline,
  shieldCheckmarkOutline,
  snowOutline,
  star,
  timeOutline,
  tvOutline,
  waterOutline,
  warningOutline,
  walletOutline,
  wifiOutline,
  wineOutline,
} from 'ionicons/icons';

export function registerIonicons(): void {
  addIcons({
    'add-outline': addOutline,
    'alert-circle-outline': alertCircleOutline,
    'arrow-forward': arrowForward,
    'arrow-undo-outline': arrowUndoOutline,
    'ban-outline': banOutline,
    'bed-outline': bedOutline,
    'business-outline': businessOutline,
    'cafe-outline': cafeOutline,
    'card-outline': cardOutline,
    'calendar-outline': calendarOutline,
    'call-outline': callOutline,
    'car-outline': carOutline,
    'chatbubble-ellipses-outline': chatbubbleEllipsesOutline,
    'chevron-forward-outline': chevronForwardOutline,
    'checkmark-circle': checkmarkCircle,
    'checkmark-outline': checkmarkOutline,
    'checkmark-done-outline': checkmarkDoneOutline,
    'chevron-back-outline': chevronBackOutline,
    'close-circle-outline': closeCircleOutline,
    'ellipse-outline': ellipseOutline,
    'chevron-down-outline': chevronDownOutline,
    'close-outline': closeOutline,
    'compass-outline': compassOutline,
    'copy-outline': copyOutline,
    'create-outline': createOutline,
    'cash-outline': cashOutline,
    'document-text-outline': documentTextOutline,
    'enter-outline': enterOutline,
    'download-outline': downloadOutline,
    'exit-outline': exitOutline,
    'eye-outline': eyeOutline,
    'flash-outline': flashOutline,
    'globe-outline': globeOutline,
    'headset-outline': headsetOutline,
    'help-circle-outline': helpCircleOutline,
    'home-outline': homeOutline,
    'information-circle-outline': informationCircleOutline,
    'key-outline': keyOutline,
    location,
    'location-outline': locationOutline,
    'lock-closed-outline': lockClosedOutline,
    'log-out-outline': logOutOutline,
    'mail-outline': mailOutline,
    'menu-outline': menuOutline,
    'notifications-outline': notificationsOutline,
    'options-outline': optionsOutline,
    'paw-outline': pawOutline,
    'people-outline': peopleOutline,
    'person-outline': personOutline,
    'pricetag-outline': pricetagOutline,
    'qr-code-outline': qrCodeOutline,
    'remove-outline': removeOutline,
    'resize-outline': resizeOutline,
    'search-outline': searchOutline,
    'share-outline': shareOutline,
    'shirt-outline': shirtOutline,
    'shield-checkmark-outline': shieldCheckmarkOutline,
    'snow-outline': snowOutline,
    star,
    'time-outline': timeOutline,
    'tv-outline': tvOutline,
    'water-outline': waterOutline,
    'wine-outline': wineOutline,
    'warning-outline': warningOutline,
    'wallet-outline': walletOutline,
    'wifi-outline': wifiOutline,
  });
}
